import { useEffect } from "react";
import { useState } from "react";
import { useSearchParams } from "next/navigation";
import { getValidPromotionData } from "@/utils/promotion";

export const getUrlOrSession_ = (searchParams) => (key, sessionKey) => {
  if (searchParams.has(key)) {
    const value = searchParams.get(key);
    sessionStorage.setItem(sessionKey || key, value);
    return value;
  }
  return sessionStorage.getItem(key) || "";
};

function useCommonData() {
  const searchParams = useSearchParams();
  const [{ promotionId, saleId, innerfromid, fromid }, setSessionData] =
    useState({ promotionId: "", saleId: "", innerfromid: "", fromid: "" });
  const [
    {
      inApp,
      inAndroid,
      inWechat,
      inIPhone,
      hideOpenApp,
      inMiniProgram,
      inMobile,
    },
    setEnv,
  ] = useState({
    inApp: false,
    inAndroid: false,
    inWechat: false,
    inIPhone: false,
    hideOpenApp: false,
    inMiniProgram: false,
    inMobile: false,
  });

  const getUrlOrSession = getUrlOrSession_(searchParams);

  useEffect(() => {
    const innerfromid = getUrlOrSession("innerfromid");
    const fromid =
      getUrlOrSession("fromid") || getUrlOrSession("from", "fromid");
    getValidPromotionData(searchParams).then(({ promotionId, saleId }) => {
      setSessionData({
        promotionId,
        saleId,
        innerfromid,
        fromid,
      });
    });

    const inApp = navigator.userAgent.includes("taocheershoucheapp");
    const inWechat = navigator.userAgent
      ?.toLowerCase()
      .includes("micromessenger");
    const inAndroid = window.navigator.userAgent?.includes("Android");
    const inIPhone = window.navigator.userAgent?.includes("iPhone");
    const inMiniProgram = navigator.userAgent?.includes("miniProgram");
    const inMobile = navigator.userAgent?.includes("Mobile");
    const hideOpenApp =
      inApp || inMiniProgram || searchParams?.get("hideType") == 6;

    setEnv({
      inApp,
      inWechat,
      inAndroid,
      inIPhone,
      hideOpenApp,
      inMiniProgram,
      inMobile,
    });
  }, []);

  return {
    promotionId,
    saleId,
    innerfromid,
    fromid,
    inApp,
    inWechat,
    inAndroid,
    inIPhone,
    hideOpenApp,
    inMiniProgram,
    inMobile,
  };
}

export default useCommonData;
